import React, { FC } from 'react';
import { useSitecoreContentQuery } from 'omni-package-react-cms';

import NeedHelpPhoneResource from './NeedHelpPhoneResource/NeedHelpPhoneResource';
import NeedHelpHoursResource from './NeedHelpHoursResource/NeedHelpHoursResource';

import NeedHelpModal from './NeedHelpModal';

export interface NeedHelpProps { }

const NeedHelp: FC<NeedHelpProps> = () => {
  const PhoneUrl = useSitecoreContentQuery('Need Help/Phone number', false);
  const HoursUrl = useSitecoreContentQuery('Need Help/Business Hours', false);
  return (
    <>
      <NeedHelpPhoneResource url={PhoneUrl} autoRequest requestOnLanguageChange />
      <NeedHelpHoursResource url={HoursUrl} autoRequest requestOnLanguageChange />
      <NeedHelpModal />
    </>
  );
};

export default NeedHelp;
